import { Add, Download, ModeEdit } from "@mui/icons-material";
import { Alert, Button, Grid, LinearProgress, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { CSVLink } from "react-csv";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { FragenKategorienTemplate } from "../../../constants/csvTemplates";
import defaultColDef from "../../../constants/defaultColDef";
import QuestionCategory from "../../../interface/question-category";
import { getQuestionCategories } from "../../../services/api.service";
import { useState } from "react";
import CategoryDetailDialog from "../../Detail/ElectionDialogs/CategoryDetailDialog";
import { SelectionChangedEvent } from "ag-grid-community";

function CategoriesDashboard(): JSX.Element {
    const params = useParams();
    const navigate = useNavigate();
    const id = params.id ? parseInt(params.id) : 0;
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [selectedCategory, setSelectedCategory] = useState<QuestionCategory>();

    const { data: categories, error, isLoading } = useQuery<QuestionCategory[]>(["questions-categories", { id }], async () => await getQuestionCategories(id));

    const handleModalClose = () => setModalOpen(false);

    const onSelectionChanged = (event: SelectionChangedEvent) => {
        const selectedRows: QuestionCategory[] = event.api.getSelectedRows();
        setSelectedCategory(selectedRows.length ? selectedRows[0] : undefined);
    }

    if (error) return <Alert severity="error">Error Loading</Alert>;
    if (isLoading) return <LinearProgress />;

    if (categories) {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12} md={8}>
                    <Typography variant={"h5"}>Fragen Kategorien</Typography>
                </Grid>
                <Grid item xs={12} md={4} display="flex" justifyContent="end">
                    <CSVLink
                        data={categories}
                        filename={`${id}-fragencategories.csv`}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        <Button variant="contained" startIcon={<Download />}>CSV Export</Button>
                    </CSVLink>
                    <CSVLink
                        data={FragenKategorienTemplate}
                        filename={`template-question-categories.csv`}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        <Button sx={{ml: 1}} variant="contained" startIcon={<Download />}>CSV Template</Button>
                    </CSVLink>
                    {selectedCategory && <Button sx={{ml: 1}} variant="contained" color="success" onClick={() => setModalOpen(true)}><ModeEdit /></Button>}
                    <Button sx={{ml: 1}} variant="contained" onClick={() => navigate(`/election/${id}/question-categories/create`)}><Add /></Button>
                </Grid>
                <Grid item xs={12}>
                    <div className="ag-theme-alpine" style={{ width: "100%", height: "70vh" }}>
                        <AgGridReact
                            rowData={categories}
                            rowSelection="single"
                            defaultColDef={defaultColDef}
                            onSelectionChanged={onSelectionChanged}
                            columnDefs={[
                                { field: 'id' },
                                { field: 'name' },
                            ]}
                        />
                    </div>
                </Grid>
                <CategoryDetailDialog
                    open={modalOpen}
                    category={selectedCategory}
                    onClose={handleModalClose}
                />
            </Grid>
        );
    }

    return <></>;
}


export default CategoriesDashboard;
